import React, { useState, useEffect } from "react";
import {
    Box,Table,Thead,Tbody,Tr,Th,Td,Button,Input,FormControl,FormLabel,Modal,ModalOverlay,ModalContent,ModalHeader,ModalCloseButton,ModalBody,ModalFooter,useDisclosure,useToast,Flex,
    Textarea,
    Switch,
    HStack,
    VStack,
    Heading,
  } from "@chakra-ui/react";
import CreatableSelect from "react-select/creatable";
import { createBlogCategory, createTag, editBlogCategory} from "../../api";
import { useNavigate } from "react-router-dom";

const AddTag = () => {
    const navigate=useNavigate();
    const toast=useToast();    
    const [formData, setFormData] = useState({
        name: "",
      });  

    
      const handleSubmit = async (e) => {
        e.preventDefault();
        // const isFormInvalid = Object.values(formData).some(value => !value);
        const requiredFields = ["name"];
        const emptyFields = requiredFields.filter((field) => !formData[field]);
      if (emptyFields.length > 0) {
        // Join the empty field names into a readable string
        const emptyFieldsMessage = `Name field is required.`;
        toast({
          title: 'Error',
          description: emptyFieldsMessage,
          status: 'error',
          duration: 5000,
          isClosable: true,
        });
        return; // Stop further execution
      }
        try {
         
            await createTag(formData);    
            navigate("/tags");
            toast({
              title: 'Tag Added Successfully.',
              description: "The tag has been added successfully.",
              status: 'success',
              duration: 5000,
              isClosable: true,
            });
          
          setFormData({ name: ""});
        } catch (error) {
          toast({
            title: 'Error',
            description: "There was an error adding the tag.",
            status: 'error',
            duration: 5000,
            isClosable: true,
          });
        }
        
      };

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (files) {
            const maxSize = 2 * 1024 * 1024; // 2MB in bytes
            if (files.size > maxSize) {
                e.target.value="";
              return toast({
                title: "An error occurred.",
                description: "File size should not exceed 2MB.",
                status: "error", // "error" for error message
                duration: 5000,  // Duration in milliseconds
                isClosable: true, // Option to close the toast
              });     
            }
          }
        setFormData((prev) => ({
          ...prev,
          [name]: files ? files[0] : value,
        }));
        
      };
  return (
    <Box
    w={{ base: "100%", md: "40%", lg: "40%" }} // Responsive width
    mx="auto" // Center align horizontally
    p={4} // Padding
    bg="gray.50" // Background color
    borderRadius="md"
    boxShadow="lg"
  >
     <form onSubmit={handleSubmit}>
     <VStack spacing={4} align="stretch" justifyContent={"flex-start"}>
     <Heading textAlign={"center"}>ADD TAG</Heading>
     <FormControl mt={4}>
              <FormLabel>Name</FormLabel>
              <Input name="name" value={formData.name} onChange={handleChange} />
            </FormControl>
              <VStack justifyContent="flex-start">
        <Button size={"lg"} bg="rgb(0 70 113 / var(--tw-bg-opacity, 1))" color={"white"} _hover={{color:"white",bg:"rgb(0 70 113 / var(--tw-bg-opacity, 1))"}} type="submit" alignSelf="flex-end">
                  Add Tag
                </Button>
                </VStack>
      </VStack>
            </form>
  </Box>
  )
}

export default AddTag;